import { NavigationPropTypes } from "./propTypes";
import "./styles.scss";

const Navigation = ({ data }) => {
  const { navigation_fix_sticky: navigationFixSticky } = data;

  return <>{navigationFixSticky && <section className="sticky-navigation-fixer-component" />}</>;
};

Navigation.propTypes = NavigationPropTypes;

export default Navigation;
